import React, { useEffect, useLayoutEffect } from 'react';
import { logAnalyticsEvent } from 'utils/packages/rnFirebase';
import { Button } from 'design-system';
import EmptyComponent from 'design-system/EmptyComponent';
import StatusBar from 'design-system/StatusBar';
import SuccessView from 'design-system/SuccessView';
import { useDisableAndroidBackButton } from 'hooks';
import Amplitude from 'utils/amplitude';
const SwitchCompleted = ({ navigation, route, }) => {
    useLayoutEffect(() => {
        navigation.setOptions({
            gestureEnabled: false,
            headerLeft: EmptyComponent,
        });
    }, []);
    useDisableAndroidBackButton();
    useEffect(() => {
        Amplitude.logEvent('MoneySuperMarket.SwitchCompleted');
        logAnalyticsEvent('Energy_Switch_Completed');
    }, []);
    const goBack = () => {
        navigation.popToTop();
    };
    const { name } = route.params;
    return (<>
      <StatusBar barStyle="dark-content" animated/>
      <SuccessView title="Success" subTitle={`${name} has received your application. They will be in touch to let you know how the switch is going and when you’ll start receiving your energy from them.\n\nYour current supplier(s) will also be in touch to confirm you’re switching away and with details around your final bill. Your switch should complete in about 4-6 weeks.\n\nNo worries, you have a 14 day "cool-off period" from today’s date. If you want to stay with old supplier(s) just contact ${name} and let them know you want to cancel the switch. You won’t pay any exit fees if you change your mind during the cool-off period.`} smallSubTitle>
        <Button brand floating title="Perfect, let’s go back!" onPress={goBack}/>
      </SuccessView>
    </>);
};
export default SwitchCompleted;
